import React, { useEffect, useState } from 'react';
import { Container, Card, Button, Form } from 'react-bootstrap';
import { FaStar } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from '../../Images/Logo.png';
import { Addrate, getRateQuestions, getSettings } from '../../redux/Slices/users/thunk';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import notify from '../../Components/Utilities/notify';




const RatePage = () => {
  const { t, i18n } = useTranslation();
  const {settings, questions, error} = useSelector((state)=> state.usersSlice)
  const [ratings, setRatings] = useState(Array(questions?.length).fill(null));
  const [comments, setComments] = useState(Array(questions?.length).fill(''));

  const [searchParams] = useSearchParams();
  const clientId = searchParams.get('clientId');
  const serviceId = searchParams.get('serviceId');
  const serviceProvider = searchParams.get('serviceProviderId');
  const reservationNumber = searchParams.get('reservationNumber');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  console.log("error",error)
  console.log("settings",settings)
  console.log("questions",questions)

  useEffect(()=>{
    dispatch(getSettings())
    if(serviceId){
      let query = `serviceId=${serviceId}`
      dispatch(getRateQuestions(query))
    }
  },[])


  const handleRatingChange = (questionIndex, value) => {
    const updatedRatings = [...ratings];
    updatedRatings[questionIndex] = value;
    setRatings(updatedRatings);
  };

  const handleCommentChange = (questionIndex, value) => {
    const updatedComments = [...comments];
    updatedComments[questionIndex] = value;
    setComments(updatedComments);
  };
  const currentLanguage = i18n.language; 
  const isArabic = currentLanguage === "ar";

  const switchLanguage = (lang) => {
    i18n.changeLanguage(lang);
    document.body.dir = lang === 'en' ? 'ltr' : 'rtl';
  };

  const handleSubmit = async (e) => {

  
    e.preventDefault();
    const questionsId = [];
    const questionsNamAr = [];
    const questionsNamEn = [];
    const rate = [];
    const notes = [];
  
    // Populate the arrays
    questions.forEach((question, index) => {
      questionsId.push(question.serial_number);
      questionsNamAr.push(question.questionsNamAr.trim());
      questionsNamEn.push(question.questionsNamEn.trim());
      rate.push(ratings[index] ? ratings[index].toString() : "0");
      notes.push(question.have_comment ? comments[index] : "");
    });
  
    // Create the final data object
    const data = {
      serviceId: serviceId, 
      questionsId,
      serviceProvider: serviceProvider,
      reservationNumber: reservationNumber,
      questionsNamAr,
      questionsNamEn,
      clientId: clientId, 
      rate,
      notes
    };
    console.log("Submitted Feedback:", data);
   await dispatch(Addrate(data))
   navigate('/HomePage')
  };

  return (

    <Container className="py-5" style={{ direction: i18n.language === 'ar' ? 'rtl' : 'ltr' }}>
      <div className="text-center mb-4">
        <img
          src={logo}
          alt="Company Logo"
          className="img-fluid"
          // style={{ maxHeight: '100px' }}
        />
        <h2 className="mt-3 fw-bold">{isArabic ? settings?.company_name : settings?.company_nameEn}</h2>
        <p className="text-muted">{t('rateExperience')}</p>
        
        {/* Language switcher */}
        <div className='fontSize'>
        <button
          onClick={() => switchLanguage("en")}
          style={{
            color: currentLanguage === "en" ? "#B49345" : "#747475",
            border: "none",
            background: "transparent",
            fontWeight: "bold",
            cursor: "pointer",
            marginRight: "10px"
          }}
        >
          EN
        </button>
        <span style={{color:"#747475"}}>|</span>
        <button
          onClick={() => switchLanguage("ar")}
          style={{
            color: currentLanguage === "ar" ? "#B49345" : "#747475",
            border: "none",
            background: "transparent",
            fontWeight: "bold",
            cursor: "pointer"
          }}
        >
          AR
        </button>
      </div>
      </div>

     { questions?.length > 0 ? <Form onSubmit={handleSubmit}>
        <Card className="shadow p-4">
          {questions?.map((question, index) => (
            <div className="mb-4" key={index}>
              <Form.Label className="fw-semibold d-block mb-2">
                {isArabic ? question.questionsNamAr : question.questionsNamEn}
              </Form.Label>
              <div className="mb-2">
                {[1, 2, 3, 4, 5].map((star) => (
                  <FaStar
                    key={star}
                    size={26}
                    className={i18n.language === 'ar' ? 'ms-1' : 'me-1'}
                    style={{
                      cursor: 'pointer',
                      color: ratings[index] >= star ? '#ffc107' : '#e4e5e9'
                    }}
                    onClick={() => handleRatingChange(index, star)}
                  />
                ))}
              </div>
              {question.have_comment && (
                <Form.Group controlId={`comment-${index}`} className="mt-2">
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder={t('commentPlaceholder')}
                    value={comments[index]}
                    onChange={(e) => handleCommentChange(index, e.target.value)}
                  />
                </Form.Group>
              )}
            </div>
          ))}

          <div className="text-center mt-4">
            <Button 
              type="submit" 
              variant="primary" 
              size="lg" 
              className="px-5 w-100" 
              style={{background:"#B49345", border:"#B49345"}}
            >
              {t('submit')}
            </Button>
          </div>
        </Card>
      </Form> : <div style={{
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  fontSize: '24px', 
  fontWeight: 'bold',
}}>
  {t('formRatedbefore')}
</div>}
    </Container>
  );
};

export default RatePage;